// extracted by mini-css-extract-plugin
module.exports = {"userLookupSelected":"UserLookupMenu_userLookupSelected__jkCaw"};